import { IMAGE_SIZE_XXL, IMAGE_SIZES, IMAGE_SIZES_MOBILE, MASONRY_IMAGE_SIZES, MASONRY_IMAGE_SIZES_HALF, } from "@/constants";
const FULLSCREEN_PARAMS = "&func=fit&bg_color=000&org_if_sml=1";
// See https://docs.cloudimage.io/transformations/image-operations/fit#examples
export const addSources = (variant) => (image) => {
    const imageSizes = variant === "fullscreen" ? IMAGE_SIZES : IMAGE_SIZES_MOBILE;
    const sources = imageSizes.map(({ w }) => ({
        media: `(max-width: ${w}px)`,
        url: `${image.url}&w=${w}${variant === "fullscreen" ? FULLSCREEN_PARAMS : ""}`,
        key: `${w}`,
    }));
    if (variant === "fullscreen") {
        sources.push({
            media: `(min-width: ${IMAGE_SIZE_XXL.w + 1}px)`,
            url: `${image.url}&w=${IMAGE_SIZE_XXL.w}${FULLSCREEN_PARAMS}`,
            key: `IMAGE_SIZE_XXL`,
        });
    }
    return Object.assign(Object.assign({}, image), { id: image.key, sources });
};
export const addMasonryDatas = ({ image, index, type, }) => {
    const imageSizes = type === "full" ? MASONRY_IMAGE_SIZES : MASONRY_IMAGE_SIZES_HALF;
    const sources = imageSizes.map(({ minW, maxW, w, h }) => {
        const media = maxW
            ? `(min-width: ${minW}px) and (max-width: ${maxW}px)`
            : `(min-width: ${minW}px)`;
        return {
            media,
            url: `${image.url}&w=${w}&h=${h}&func=crop`,
            key: `${minW}`,
        };
    });
    return Object.assign(Object.assign({}, image), { sources, originIndex: index });
};
export const getOriginIndex = (image, index) => (Object.assign(Object.assign({}, image), { originIndex: index }));
export const buildMasonryArray = (images) => {
    const imagesCount = images.length;
    // the processing is different if the number of images is a multiple of 3,
    // there are 2 half images at the end of the masonry otherwise there are 2 full images
    const masonryAdjust = imagesCount % 3 === 0 ? 0 : -1;
    return images
        .flatMap((image, index, array) => {
        const prevIndex = index - 1;
        // if it is the first image of a block of 2 half images, return nothing
        // this image is always after a full image
        if (index % 2 < 2 &&
            prevIndex % 3 === 0 &&
            index < imagesCount + masonryAdjust)
            return [];
        // if it is the second image of a block of 2 half images, return the 2 images (prev and current)
        const isHalfLayout = prevIndex % 3 < 2 &&
            prevIndex % 3 !== -1 &&
            index < imagesCount + masonryAdjust;
        if (isHalfLayout) {
            const prevImage = array[prevIndex];
            return {
                type: "half",
                item: [
                    addMasonryDatas({
                        image: prevImage,
                        index: prevIndex,
                        type: "half",
                    }),
                    addMasonryDatas({ image, index, type: "half" }),
                ],
            };
        }
        else {
            // else return the full image
            return {
                type: "full",
                item: [addMasonryDatas({ image, index, type: "full" })],
            };
        }
    })
        .filter(Boolean);
};
